<template>
	<view class="activity-item" @click="$emit('select')">
		<view class="activity-message">
			<image src="../../static/uni.png" mode=""></image>
			<view class="message-container">
				<view class="merchant-title">3.8女神节免费领饮品活动</view>
				<view class="activity-option">
					<text class="activity-option-label">活动时间：</text>
					<text class="activity-option-value">03-12 09:00～04-12 18:00</text>
				</view>
				<view class="activity-option">
					<text class="activity-option-label">活动价格：</text>
					<text class="activity-option-value">¥40</text>
				</view>
				<view class="activity-option">
					<text class="activity-option-label">报名情况：</text>
					<text class="activity-option-value">3/100人</text>
				</view>
			</view>
			<view class="activity-status" v-if="itme.status==0">未开始</view>
			<view class="activity-status" v-if="itme.status==1">进行中</view>
			<view class="activity-status" v-if="itme.status==2">已结束</view>
		</view>
		<view class="bottom-line">
			<text>创建于2023-03-12 19:00</text>
			<view class="bottom-actions">
				<view class="action" @click="$emit('deleteAction')" v-if="itme.status==0">删除</view>
				<view class="action" @click="$emit('showApply')" v-if="itme.status==1||itme.status==2">查看报名</view>
				<view class="action del-actions" @click="$emit('editAction')">编辑</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		name:"merchantActivityItem",
		props: {
			itme: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				delActivity() {
					this.$emit('deleteAction')
				}
			};
		}
	}
</script>

<style lang="scss" scoped>
.activity-item {
	background-color: #fff;
	padding: 28rpx 32rpx;
	border-bottom: 10px solid #f7f7f7;
	// height: 200rpx;
	.activity-message {
		display: flex;
		image {
			width: 100rpx;
			height: 100rpx;
			border-radius: 8rpx;
			margin-right: 18rpx;
		}
		.message-container {
			flex: 1;
			.merchant-title {
				height: 30rpx;
				font-size: 30rpx;
				font-weight: 600;
				color: #222222;
				line-height: 30rpx;
			}
			.activity-option {
				font-size: 24rpx;
				font-weight: 400;
				color: #666666;
				line-height: 24rpx;
				margin-top: 20rpx;
				.activity-option-label {
					color: #666666;
				}
				.activity-option-value {
					color: #333333;
				}
				
			}
			
		}
		.activity-status {
			ont-size: 26rpx;
			font-weight: 400;
			color: #D20A0A;
			line-height: 26rpx;
		}
	}
	.bottom-line {
		margin-top: 26rpx;
		display: flex;
		justify-content: space-between;
		height: 52rpx;
		font-size: 24rpx;
		font-weight: 400;
		color: #999999;
		line-height: 52rpx;
		.bottom-actions {
			width: 304rpx;
			display: flex;
			justify-content: space-between;
			.action {
				width: 144rpx;
				height: 52rpx;
				border-radius: 28rpx;
				border: 2rpx solid #D9D9D9;
				box-sizing: border-box;
				font-size: 26rpx;
				font-weight: 400;
				color: #333333;
				text-align: center;
			}
			.del-actions {
				border: 2rpx solid #D20A0A;
				color: #D20A0A;
			}
		}
	}
}
</style>